import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const Contact = () => {
  // loading
  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
  }, []);

  return (
    <div>
      <div>

        <>
          <>
            <ScrollToTop />
          </>
          <>
            {/* section */}
            <section className="my-lg-14 my-8">
              {/* container */}
              <div className="container">
                <div className="row">
                  {/* col */}
                  <div className="offset-lg-2 col-lg-8 col-12">
                    <iframe aria-label='Inquiry Form' frameborder="0" style={{ height: "800px", width: "99%", border: "none" }} src='https://forms.zohopublic.com/rccrmkanpur1/form/CancellationRequestForm/formperma/_ayTTb5XKnKEdDZIFyUSor-T8bg3vKYS3ctFueWVPtA' >
                    </iframe>
                    {/* <div className="mb-8">
                        
                        <h1 className="h3">Retailer Inquiries</h1>
                        <p className="lead mb-0">
                          This form is for retailer inquiries only. For all
                          other customer or shopper support requests, please
                          visit the links below this form.
                        </p>
                      </div> */}
                    {/* form */}
                    {/* <form className="row">
                        
                        <div className="col-md-6 mb-3">
                          <label className="form-label">
                            {" "}
                            First Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Your First Name"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                        
                          <label className="form-label">
                            {" "}
                            Last Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Your Last name"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                         
                          <label className="form-label">
                            {" "}
                            Company<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Company"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          
                          <label className="form-label"> Title</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Title"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">
                            Email<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Your First Name"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                        
                          <label className="form-label"> Phone</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Phone Number"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          
                          <label className="form-label"> Comments</label>
                          <textarea
                            rows={3}
                            className="form-control"
                            placeholder="Additional Comments"
                            defaultValue={""}
                          />
                        </div>
                        <div className="col-md-12">
                      
                          <Link to="#" className="btn btn-primary">
                            Submit
                          </Link>
                        </div>
                      </form> */}
                  </div>
                </div>
              </div>
            </section>
          </>
        </>

      </div>
    </div>
  );
};

export default Contact;
